import  React from 'react'
import TDCSpecialtyLogo from "../assets/TDCSIC-TDCG_White.png"

function PageNotFound() {

    return (
        <div className='w-screen p-10 flex flex-col justify-start h-screen relative bg-black'>
    <div className='w-full h-fit'>
        <img className='w--auto h-20' src={TDCSpecialtyLogo} alt="" />
    </div>
    <div className='px-20'>
    <div className='text-white my-20 w-fit'>
        <h1 className='text-5xl'>404 Page Not Found</h1>
        {/* <h5 className=' text-shadow-lg text-2xl font-light'>BUSINESS INTELLIGENCE DASHBOARDS IN REAL-TIME</h5> */}
    </div>
    <div>
    

    </div>
    </div>

    </div>
   
    )
}

export default PageNotFound